import React from 'react';
import PropTypes from 'prop-types';

import Link, { propTypes as linkPropTypes } from '../../../../01_atoms/Link';
import Button from '../../../../01_atoms/Button';
import TagText from '../../../../01_atoms/Tag/TagText';
import DefaultPicture, { propTypes as picturePropTypes } from '../../../../01_atoms/DefaultPicture';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../../utils/behaviorSettings';

import styles from './index.module.scss';
import gStyles from '../index.module.scss';

const BBCTAEmergencyPrimary = ({
  imagePicture,
  button = null,
  title = '',
  list = [],
  emergencyLabel = null,
  showDEC = false,
  behaviorSettings = null,
  uuid = null,
}) => {
  const componentName = 'bb-cta-emergency-primary';
  return (
    <div
      className={`bb cta ${gStyles['cta']} ${styles[componentName]} ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
      data-component={componentName}
      id={uuid}
    >
      <div className={`${styles[componentName + '__inner']}`}>
        {imagePicture && <DefaultPicture {...imagePicture} loading="lazy" />}

        {showDEC && (
          <div>
            <div className={`${styles[componentName + '__red-strip']}`} />
            <img
              src="/static/icons/DEC.svg"
              className={`${styles[componentName + '__watermark']}`}
              alt="DEC logo"
              width={95}
              height={165}
            />
          </div>
        )}
      </div>

      <div className="container">
        <div className={`${styles[componentName + '__overlay']}`}>
          <div className={`${styles[componentName + '__emergency-tag-label']}`}>
            <TagText label="Emergency" backgroundColor="red" borderColor="red" isUppercase />

            {emergencyLabel && (
              <TagText
                label={emergencyLabel}
                backgroundColor="black"
                borderColor="red"
                isUppercase
              />
            )}
          </div>

          {title && <h2 className={`${styles[componentName + '__title']}`}>{title}</h2>}

          {list.length > 0 && (
            <ul className={`${styles[componentName + '__icon-list']}`}>
              {list.map((item) => (
                <li key={item} className={`${styles[componentName + '__icon-list-item']}`}>
                  <p>{item}</p>
                </li>
              ))}
            </ul>
          )}

          {button && button.label && button.nextLink && (
            <Link {...button.nextLink}>
              <Button tag="a" href={button.nextLink.url} type="emergency">
                {button.label}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

BBCTAEmergencyPrimary.propTypes = {
  imagePicture: PropTypes.shape(picturePropTypes).isRequired,
  title: PropTypes.string,
  button: PropTypes.shape({
    label: PropTypes.string.isRequired,
    nextLink: PropTypes.shape(linkPropTypes).isRequired,
  }),
  list: PropTypes.arrayOf(PropTypes.string),
  showDEC: PropTypes.bool,
  emergencyLabel: PropTypes.string,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBCTAEmergencyPrimary;
